import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useMemo, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Checkbox, Form, FormField, Header, Input, List, SpaceBetween } from '@cloudscape-design/components';
import { mdiCheck, mdiLockOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import HorizontalRule from '../../../../../components/HorizontalRule';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemEquipment } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { ItemCategory } from '../../comm/news/list';

interface ItemAltitude {
    idEquipment: number;
    altitude: number;
    cost: number;
}

export const MasterEquipmentsRatesPage = () => {
    const { data, menu, parameters } = useGlobalState();
    const [idEquipment, setIdEquipment] = useState(0);
    const [equipment, setEquipment] = useState<ItemEquipment>();
    const [idCategory, setIdCategory] = useState(0);
    const [updateCategory, setUpdateCategory] = useState(0);

    const filteredEquipments = useMemo(() => data.equipments.filter((e: ItemEquipment) => e.idCategory === idCategory && e.groupTypeMasterCode === "GLIDER"),
        [data.equipments, idCategory]
    );

    const altitudes = [1200, 1450, 1700, 2200, 2700, 3200];
    const handleGetEquipment = async () => {
        try {
            if (idCategory > 0) {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/equipments/get',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({ idEquipment: idEquipment }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    const rawAltitudes = data.equipment.jsonAltitudes || [];

                    const normalizedAltitudes = altitudes.map((alt) => {
                        const existing = rawAltitudes.find(
                            (a: any) => Number(a.altitude) === alt
                        );
                        const costValue = existing?.cost ? parseFloat(existing.cost) : 0;
                        return {
                            idEquipment: data.equipment.idEquipment,
                            altitude: alt, // Already a number from the altitudes array
                            cost: costValue
                        };
                    });

                    setEquipment({
                        ...data.equipment,
                        jsonAltitudes: normalizedAltitudes
                    });
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    };


    const handleUpdate = async () => {
        try {

            setLoading(true)
            let body = {}
            if (updateCategory === 1) {
                body = {
                    idCategory: idCategory,
                    jsonAltitudes: equipment.jsonAltitudes,
                    hourCost: equipment.hourCost
                }
            } else {
                body = {
                    idEquipment: equipment.idEquipment,
                    jsonAltitudes: equipment.jsonAltitudes,
                    hourCost: equipment.hourCost
                }
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/updaterates',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setUpdateCategory(0);
                setIdEquipment(0);
                setEquipment(undefined)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    useEffect(() => {
        if (idEquipment > 0) {
            handleGetEquipment();
        } else {
            setEquipment(undefined);
        }

    }, [idEquipment]);
    console.log(filteredEquipments)
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content max-content 1fr', gap: '1rem', width: '100%', alignItems: 'start' }}>
                        <div style={{ width: 210 }}>
                            <Header variant="h3">Categorías</Header>
                            <List
                                items={data.categories
                                    .filter((eq: ItemCategory) => eq.hasAltitudes === 1)
                                    .map((eq: ItemCategory) => ({
                                        id: eq.idCategory.toString(),
                                        content: (<span style={{ cursor: "pointer", fontWeight: idCategory.toString() === eq.idCategory.toString() ? "bold" : "normal" }}
                                            onClick={() => {
                                                setIdCategory(eq.idCategory)
                                                setEquipment(undefined);
                                                setIdEquipment(0)
                                            }}
                                        >{eq.category}</span>),
                                    }))}
                                renderItem={item => ({
                                    id: item.id,
                                    content: item.content,
                                    actions: (
                                        idCategory.toString() === item.id && <Icon path={mdiCheck} size={1} />
                                    )
                                })}
                            />
                        </div>
                        {!!idCategory && (
                            <div>
                                <Header variant="h3">Material</Header>
                                <List
                                    items={filteredEquipments.map((eq: ItemEquipment) => ({
                                        id: eq.idEquipment.toString(),
                                        description: eq.make + " " + eq.model,
                                        content: (
                                            <span style={{ cursor: "pointer", fontWeight: idEquipment.toString() === eq.idEquipment.toString() ? "bold" : "normal" }}
                                                onClick={() => {
                                                    setUpdateCategory(0)
                                                    setIdEquipment(eq.idEquipment);
                                                }}
                                            >
                                                {eq.registration} {eq.jsonOwners.length > 0 ? <Icon path={mdiLockOutline} size={0.7} /> : null}
                                            </span>
                                        ),
                                    }))}
                                    renderItem={item => ({
                                        id: item.id,
                                        content: item.content,
                                        secondaryContent: (
                                            <Box variant="small">{item.description}</Box>
                                        ),
                                        actions: (
                                            idEquipment.toString() === item.id && <Icon path={mdiCheck} size={1} />
                                        )
                                    })}
                                />
                            </div>
                        )}

                        {!!equipment && (
                            <div>
                                <Header variant="h3">Hora de vuelo</Header>
                                <div style={{ width: 130 }}>
                                    <FormField key={"horavuelo"} label={`Costo`}
                                        constraintText={formatCurrency(equipment.hourCost * data.UF, "CLP")}>
                                        <Input type='number' value={equipment.hourCost.toString() ?? "0"}
                                            onChange={(e) => {
                                                // Allow the user to type/update the state directly
                                                console.log(e.detail.value)
                                                const newCost = parseFloat(e.detail.value);
                                                setEquipment({
                                                    ...equipment,
                                                    hourCost: newCost

                                                });
                                            }}
                                            onBlur={() => {
                                                setEquipment((prev) => ({
                                                    ...prev,
                                                    hourCost: parseFloat(prev.hourCost.toFixed(2)) ?? 0
                                                }));
                                            }}

                                        />
                                    </FormField>
                                </div>
                            </div>
                        )}

                        {!!equipment && (
                            <div>

                                <Header variant="h3">Remolques</Header>
                                <Form actions={
                                    <>
                                        <HorizontalRule />
                                        <SpaceBetween size="s" direction='horizontal'>
                                            <Checkbox checked={updateCategory === 1}
                                                onChange={({ detail }) => setUpdateCategory(detail.checked ? 1 : 0)}
                                                description="Aplicar tarifas a toda la categoría"
                                            >Actualizar masivo
                                            </Checkbox>

                                            <Button variant="primary" onClick={() => {
                                                handleUpdate();
                                            }}>Actualizar</Button>
                                        </SpaceBetween>
                                    </>
                                }>
                                    <SpaceBetween direction="horizontal" size="xs">
                                        {altitudes.map((altitude: number) => (
                                            <div style={{ width: 130 }}>
                                                <FormField key={altitude} label={`${altitude} metros`}
                                                    constraintText={formatCurrency((equipment.jsonAltitudes.find((a: ItemAltitude) => a.altitude === altitude)?.cost ?? 0) * data.UF, "CLP")}
                                                >
                                                    <Input type='number' value={equipment.jsonAltitudes.find((a: ItemAltitude) => a.altitude === altitude)?.cost ?? 0}
                                                        onChange={(e) => {
                                                            // Allow the user to type/update the state directly
                                                            const newCost = e.detail.value;
                                                            const updatedAltitudes = [...equipment.jsonAltitudes];
                                                            const index = updatedAltitudes.findIndex((a) => a.altitude === altitude);

                                                            if (index !== -1) {
                                                                updatedAltitudes[index] = { ...updatedAltitudes[index], cost: newCost };
                                                            } else {
                                                                updatedAltitudes.push({ altitude, cost: newCost, idEquipment: equipment.idEquipment });
                                                            }

                                                            setEquipment({
                                                                ...equipment,
                                                                jsonAltitudes: updatedAltitudes,
                                                            });
                                                        }}
                                                        onBlur={() => {
                                                            setEquipment((prev) => ({
                                                                ...prev,
                                                                jsonAltitudes: prev.jsonAltitudes.map((a) =>
                                                                    a.altitude === altitude
                                                                        ? {
                                                                            ...a,
                                                                            cost: parseFloat(Number(a.cost).toFixed(2))
                                                                        }
                                                                        : a
                                                                ),
                                                            }));
                                                        }}
                                                    />
                                                </FormField>
                                            </div>
                                        ))}
                                    </SpaceBetween>
                                </Form>
                            </div>
                        )}

                    </div>
                </SpaceBetween>

            }
        />
    );
};
